<template>
  <!-- 
    
    這個好像沒用到了
  
   -->
  <div class="ad-comp">
    <img class="img-responsive" :src="adImg.path" alt @click="handleBlockClick(adv1.linkurl)"/>
  </div>
</template>

<script>
export default {
  props: ["adImg"], // 会有path 和 linkurl
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleBlockClick(link) {
      if(!link) return;
      // window.open(link, '_blank');
      // location.href = link;
      this.linkToRouter(link);
    }
  },
  components: {},
};
</script>

<style scoped lang='less'>
.ad-comp {
  margin: 0 auto;
  height: 657px;
  margin-top: 25px;
  margin-bottom: 45px;
  // max-width: 1386px;
  @media (max-width: 992px) {
    width: 100%;
    height: auto;
  }
}
</style>
